export default __webpack_public_path__ + "static/media/lightning.664d7df0.svg";